const paymentRefusals = new WeakSet();

// One sentence per credit-plan refusal (D74); billing is managed by the company owner.
const publicMessages = {
  plan_required:
    'Your company needs an active plan to continue. A company owner can choose one in Usage.',
  credits_exhausted:
    'Your company has used its credits. A company owner can change the plan in Usage to continue.',
  member_limit_reached:
    'You have reached your monthly credit limit. A company owner can raise it in Usage.',
};
const fallbackMessage =
  'Your company cannot start new work right now. A company owner can check the plan in Usage.';

export function paymentRequiredMessage(detail = null) {
  return typeof detail === 'string' && Object.hasOwn(publicMessages, detail)
    ? publicMessages[detail]
    : fallbackMessage;
}

/** An account refusal before provider admission; it grants no credit or retry. */
export class UsagePaymentRequiredError extends Error {
  constructor(detail = null) {
    super('payment_required');
    this.name = 'UsagePaymentRequiredError';
    this.code = 'usage_not_authorized';
    this.reason = 'payment_required';
    this.detail = Object.hasOwn(publicMessages, detail ?? '') ? detail : null;
    this.statusCode = 402;
    this.publicMessage = paymentRequiredMessage(this.detail);
    paymentRefusals.add(this);
  }
}

/** Recognize only the actual native refusal, never a provider's matching text. */
export function isUsagePaymentRequiredError(error) {
  return error !== null && typeof error === 'object' && paymentRefusals.has(error);
}
